import './LiveOnlineUsersSheet.sass';

import React, { FC, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  liveActions,
  liveShowUsersSheetSelector,
  liveOnlineUsersSelector,
  LiveOnlineUsersLoadingStatusSelector,
} from '$store/live';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { AnimatedEmoji, Placeholder, ScrollView } from '$uikit';
import { LiveUserCell } from '$core/Live/LiveUserCell/LiveUserCell';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';

export const LiveOnlineUsersSheetInner: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const status = useSelector(LiveOnlineUsersLoadingStatusSelector);
  const users = useSelector(liveOnlineUsersSelector);

  useEffect(() => {
    dispatch(liveActions.getOnlineUsers({}));
    const getOnlineUsers = () =>
      dispatch(liveActions.getOnlineUsers({ skipLoading: true }));
    const interval = setInterval(getOnlineUsers, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="LiveOnlineUsersSheet">
      {status === 'failed' ? (
        <Placeholder title="error" />
      ) : status === 'loading' ? (
        <Loader isWrapped />
      ) : users.length ? (
        <ScrollView>
          {users.map((userId) => (
            <LiveUserCell
              onClick={() => {
                dispatch(liveActions.showActionsSheet(userId));
              }}
              userId={userId}
              key={userId}
            />
          ))}
        </ScrollView>
      ) : (
        <Placeholder
          iconSize={112}
          icon={<AnimatedEmoji loop emoji={'🙈'} />}
          title={t('live_online_users_sheet_placeholder_title')}
        >
          {t('live_online_users_sheet_placeholder_desc')}
        </Placeholder>
      )}
    </div>
  );
};

// eslint-disable-next-line react/display-name
export const LiveOnlineUsersSheet: FC = memo(() => {
  const active = useSelector(liveShowUsersSheetSelector);
  const t = useTranslator();
  const dispatch = useDispatch();
  if (!active) return null;

  return (
    <BottomSheet
      title={t('live_online_users_sheet_title')}
      onClose={() => dispatch(liveActions.setOnlineUsersSheet(false))}
    >
      <LiveOnlineUsersSheetInner />
    </BottomSheet>
  );
});
